export default "__VITE_ASSET__C3spa02m__"